// Import model
import { CreateCustomerReviewRequest } from '../models/CreateCustomerReviewRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateCustomerReviewRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateCustomerReviewRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateCustomerReviewRequest instance
   */
  static deserialize(json: string): CreateCustomerReviewRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateCustomerReviewRequest instance
   */
  static fromObject(obj: any): CreateCustomerReviewRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateCustomerReviewRequest');
    }


    const instance: CreateCustomerReviewRequest = {
      provider: obj['provider'] as string | undefined,
      description: obj['description'] as string | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      isActive: obj['isActive'] as boolean | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateCustomerReviewRequest instances
   */
  static deserializeArray(json: string): CreateCustomerReviewRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateCustomerReviewRequest instance to a JSON string
   */
  static serialize(instance: CreateCustomerReviewRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateCustomerReviewRequest instance to a plain object
   */
  static toObject(instance: CreateCustomerReviewRequest): any {
    return {
      'provider': instance.provider,
      'description': instance.description,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'isActive': instance.isActive,
    };
  }

  /**
   * Serializes an array of CreateCustomerReviewRequest instances to a JSON string
   */
  static serializeArray(instances: CreateCustomerReviewRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
